module.exports = __webpack_public_path__ + "studers.8eec3677.svg";